import { useCallback } from 'react';

import useSetProtectionModalCartItemId from './useSetProtectionModalCartItemId';

const useResetProtectionModalCartItemId = () => {
  const setProtectionModalCartItemId = useSetProtectionModalCartItemId();

  const resetProtectionModalCartItemId = useCallback(() => {
    setProtectionModalCartItemId(null);
  }, [setProtectionModalCartItemId]);

  return resetProtectionModalCartItemId;
};

export default useResetProtectionModalCartItemId;
